import { ApiListings, ApiSellers } from '@cf/api-v2-types';
import { simpleCreateMutation, simpleCreateQuery } from '$lib/utils/simpleQueryMutations';
import type { SellersParameters, BrandSellersParameters } from '@cf/api-v2-types';

export const useSellersReadQuery = () => {
	return simpleCreateMutation(async (data: SellersParameters) => {
		const apiSellers = new ApiSellers('/proxy');
		return apiSellers.read(data);
	});
};

export const useSellersCreateMutation = () => {
	return simpleCreateMutation<any>(async (data: unknown) => {
		const apiSellers = new ApiSellers('/proxy');

		const result = await apiSellers.create(data);
		return result;
	});
};

export const useSellersExportQuery = () => {
	return simpleCreateMutation(async (data: SellersParameters) => {
		const apiSellers = new ApiSellers('/proxy');
		const result = await apiSellers.export(data);
		return result;
	});
};

export const useGetSellersDetailMutation = () => {
	return simpleCreateMutation<any>(async (data: { id: string }) => {
		const apiSellers = new ApiSellers('/proxy');
		const result = await apiSellers.sellerDetail(data);
		return result;
	});
};

export const useSellersUpdateMutation = () => {
	return simpleCreateMutation<any>(async (data: unknown) => {
		const apiSellers = new ApiSellers('/proxy');

		const result = await apiSellers.update(data);
		return result;
	});
};

export const useSellersDeleteMutation = () => {
	return simpleCreateMutation<any>(async (data: {id: string, type: string}) => {
		const apiSellers = new ApiSellers('/proxy');

		const result = await apiSellers.delete(data);
		return result;
	});
};

export const useProviderStatusQuery = () => {
	return simpleCreateMutation(async (data: any) => {
		const apiSellers = new ApiSellers('/proxy');
		return apiSellers.updateProviderStatus(data);
	});
};
export const useBrandSellersReadQuery = () => {
	return simpleCreateMutation(async (data: BrandSellersParameters) => {
		const apiSellers = new ApiSellers('/proxy');
		return apiSellers.readBrandSeller(data);
	});
};

export const useBrandsSellersDeleteMutation = () => {
	return simpleCreateMutation<any>(async (data: { brand_id: string; provider_id: string }) => {
		const apiSellers = new ApiSellers('/proxy');

		const result = await apiSellers.deleteBrandProvider(data);
		return result;
	});
};
export const useSellersStatusUpdateMutation = () => {
	return simpleCreateMutation<any>(async (data: unknown) => {
		const apiSellers = new ApiSellers('/proxy');
		const result = await apiSellers.updateStatus(data);
		return result;
	});
};

export const useSellerStatusListingCountsMutation = () => {
	return simpleCreateMutation(async (provider_id: number | string) => {
		const apiSellers = new ApiSellers('/proxy');
		const result = await apiSellers.getSellerStatusListingCounts(provider_id)
		return result;
	})
}

export const useSellerByMarketplaceMutation = () => {
	return simpleCreateMutation(async (marketplace_id: string) => {
		const apiSellers = new ApiSellers('/proxy');
		const result = await apiSellers.getSellerByMarketplace(marketplace_id)
		return result;
	})
}

export const useSellerByIdQuery = () => {
	return simpleCreateMutation(async (data: {id: string, brand_id?: string, islisting_details?: boolean}) => {
		const apiSellers = new ApiSellers('/proxy');
		const result = await apiSellers.getSellerById(data.id, data.brand_id, data.islisting_details)
		return result;
	})
}